export default __webpack_public_path__ + "static/media/PUBLI_2_ORG_12.9a777a2f.png";